import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import DeleteIcon from '@mui/icons-material/Delete';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { IconButton, Tooltip } from '@mui/material';
import { Article } from '../../../common/model/dto/article';
import { Resource } from '../../../common/model/type/resource.enum';
import useAuthorized from '../../../hooks/use-authorized';

interface OvArticleRowActionsProps {
  article: Article;
  onDelete: (articleId: string) => void;
}

const OvArticleRowActions: FC<OvArticleRowActionsProps> = ({
  article,
  onDelete,
}) => {
  const { t } = useTranslation();
  const applicationOperations = useAuthorized(Resource.Application);
  const articleOperations = useAuthorized(Resource.Article);
  const articleDeleteAllowed =
    articleOperations.delete || applicationOperations.supervise;

  return (
    <>
      <Tooltip title={t('articles.actions.delete')}>
        <span>
          <IconButton
            size="small"
            aria-label={t('articles.actions.delete')}
            disabled={!articleDeleteAllowed}
            onClick={() => onDelete(article.id as string)}
          >
            <DeleteIcon />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title={t('articles.actions.read')}>
        <IconButton
          size="small"
          component="a"
          href={article.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={t('articles.actions.read')}
        >
          <OpenInNewIcon />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default OvArticleRowActions;
